import { render } from "./ProjectStarFighter.vue?vue&type=template&id=64431ac8"
import script from "./ProjectStarFighter.vue?vue&type=script&lang=js"
export * from "./ProjectStarFighter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__